var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('expansion-update-form',{attrs:{"schema":_vm.siteSchema,"id":_vm.id,"initialLoad":_vm.initialLoad,"storeNamespace":"settings","objectNamespace":"O_site"}})}
var staticRenderFns = []

export { render, staticRenderFns }